import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { App } from './App.js'
import { ohneAbfrage } from './besuchszaehlung.js'
import './tokens.css'
import './styles.css'
/*
  Nach `office.css` geladen, das `App.js` oben mitbringt: Die Fehlerzustände
  der Belegerfassung sollen die Feldregeln des Büros überschreiben können.
*/
import './belegfehler.css'
import './filterleiste.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    {/*
      Die Besuchszählung von Vercel – genau hier und nirgends sonst.

      Einmal im Wurzelbaustein eingehängt, damit es keine zweite Stelle gibt,
      die dasselbe Skript nachlädt. Es setzt kein Cookie und legt keine
      Kennung im Browser ab; der Anbieter unterscheidet Besucher über einen
      Hashwert aus der Anfrage, der nach einem Tag verfällt.

      `beforeSend` schneidet die Abfrage von der Adresse ab, BEVOR etwas
      hinausgeht – die Begründung steht in `besuchszaehlung.ts`, und sie ist
      der Grund, warum diese Zeile nicht weggelassen werden darf.

      `mode` wird gesetzt und nicht geraten. Die Vorgabe `auto` liest
      `process.env.NODE_ENV`; was davon im gebauten Bündel ankommt, hängt an
      der Baukette. `import.meta.env.PROD` ist die Angabe von Vite selbst und
      stimmt in beiden Richtungen: im Betrieb wird gezählt, auf dem
      Entwicklungsrechner nicht.
    */}
    <Analytics
      mode={import.meta.env.PROD ? 'production' : 'development'}
      beforeSend={ohneAbfrage}
    />
  </StrictMode>
)
